import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";

import * as yup from "yup";

import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  LinearProgress,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";

import RefreshIcon from "@mui/icons-material/Refresh";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

import { auth } from "@jumbo/services/auth/firebase/firebase";
import { useAuthSignInWithEmailAndPassword } from "@react-query-firebase/auth";

import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { useJumboApp } from "@jumbo/hooks";

import { LAYOUT_NAMES } from "../../../layouts/layouts";
import { fetchError } from "../../../redux/actions/Common";

import {
  onLoginCli,
  onActualizarOtp,
  obtenerRegistroCliente,
  onEnviarOtpSms,
} from "../services/index";

import InfoPopoverButton from "app/modules/shared/components/InfoPopoverButton";

import { consultarGrupoGenerico } from "app/modules/app-configuracion/services/configuracionServices";
import { preevaluacionCliente, preevaluacionClienteCredito } from "app/modules/app-credito/services/creditoServices";

import { useOnLogin } from "../hook";
import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";

import RedirectToHome from "../components/RedirectToHome";

import { useTranslation } from "react-i18next";
import { ORIGIN_CONNECT } from "app/config/globals";
import { set } from "date-fns";

const validationSchema = yup.object({
  cedula: yup.string("Ingrese su Cédula").required("Cédula es obligatorio"),
  password: yup.string("Ingrese su Clave").required("Clave es obligatoria"),
});

const Login1 = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  //const origen = localStorage.getItem("origen");
  //localStorage.setItem("origen", origen);

  const [origen, setOrigen] = useState(localStorage.getItem("origen"));
  const history = useHistory();
  const { setActiveLayout } = useJumboApp();
  const [send, setSend] = useState(false);

  useOnLogin(send, setSend);
  const [color, setColor] = useState("");
  const [url, setUrl] = useState("");
  const { authUser } = useSelector(({ auth }) => auth);
  const [open, setOpen] = useState(false);
  const [mensajeCliente, setMensajeCiente] = useState("");
  const [continuaProceso, setContinuaProceso] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [celularOtp, setCelularOtp] = useState(null);
  const [nombresOtp, setNombresOtp] = useState("");

  const [esperaLogin, setesperaLogin] = useState(true);
  const [loggedUser, setLoggedUser] = useState(false);
  const [mostarRefresh, setMostrarRefresh] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [flujoFinal, setFlujoFinal] = useState("");
  const [datosPreevaluacion, setDatosPreevaluacion] = useState({});
  const [mostrarAprobado, setMostrarAprobado] = useState(false);
  const [mostrarNegado, setMostrarNegado] = useState(false);
  const [dactilarUsr, setDactilarUsr] = useState(null);

  useEffect(() => {
    //sessionStorage.setItem("conectado", false);
    //setSend(true);
    setActiveLayout(LAYOUT_NAMES.SOLO_PAGE);

    setTimeout(() => {
      setSend(true);
      //obtenerGrupo();
    }, 50);

    setTimeout(() => {
      //console.log("paso 2");
      //setSend(true)
      obtenerGrupo();
    }, 3000);

    setTimeout(() => {
      loggedUser ? setMostrarRefresh(true) : setMostrarRefresh(true);
    }, 8000);

    switch (origen) {
      case "tvtas":
        setColor("#FF9201");
        setUrl("https://www.tventas.com/content/55-creditventas");
        break;
      case "corpfav":
        setColor("#e1251b");
        setUrl("https://www.creditofavorito.com/");
        break;
      default:
        setColor("#e1251b");
        setUrl("https://www.creditofavorito.com/");
        break;
    }

    const obtenerGrupo = async () => {
      try {
        const resp = await consultarGrupoGenerico(origen, 1);
        if (resp.state) {
          //localStorage.setItem("tipocliente", "NUEVO");
          localStorage.setItem("idGrupoStorage", resp.data[0].codigo);
          setLoggedUser(true);
        } else {
          console.log(resp.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    return () => {
      setSend(false);
    };
  }, [refresh]);

  const iniciarSesionGenerico = async () => {
    //console.log("entro generico");
    setSend(true);
  };

  const obtenerGrupo2 = async () => {
    /* console.log("enttro a grupo 2"); */
    const resp = await consultarGrupoGenerico(origen, 1);
    if (resp.state) {
      //localStorage.setItem("tipocliente", "NUEVO");
      localStorage.setItem("idGrupoStorage", resp.data[0].codigo);
      setLoggedUser(true);
    } else {
      console.log(resp.message);
    }
  };

  const handleCloseEspera = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      //console.log(reason);
      setesperaLogin(true);
    } else {
      setesperaLogin(false);
    }
  };

  const mutation = useAuthSignInWithEmailAndPassword(auth, {
    onError(error) {
      console.log(error);
    },
    onSuccess(data) {
      history.push("/");
    },
  });

  // const onSignIn = async (cedula, password) => {
  //   //debugger;
  //   try {
  //     localStorage.setItem("tipocliente", "EXISTE");
  //     let response = await onLoginCli(cedula, password);
  //     if (response.state) {
  //       sessionStorage.setItem("jwtToken", response.data.jwt.accessToken);

  //       let cedula = localStorage.getItem("cedula");
  //       let email = localStorage.getItem("email");

  //       response = await onActualizarOtp(email, cedula);
  //       if (response.state) {
  //         localStorage.setItem("tipocliente", "EXISTE");

  //         history.push("/auth-pages/otp");
  //       } else {
  //         alert(response.message);
  //         //dispatch(fetchError(data.message))
  //       }

  //       //history("/home/home"); history("/home/home");
  //     } else {
  //       dispatch(fetchError(response.message));
  //     }
  //   } catch (e) {
  //     dispatch(fetchError(e.message));
  //   }

  //   //     await onLoginCli(cedula, password)
  //   //       .then((response) => {

  //   //         console.log(response);
  //   //         if (response.state) {
  //   //             // guarda el token
  //   //             sessionStorage.setItem('jwtToken', data.data.jwt.accessToken);

  //   //             history("/home/home", {replace: true});
  //   //         } else console.log(response.message);
  //   //       })
  //   //       .catch((e) => {
  //   //         console.log(e);
  //   //       })
  // };

  const onSignIn = async (cedula, password, setSubmitting) => {
    localStorage.setItem("tipocliente", "NUEVO");
    let response = await onLoginCli(cedula, password);
    //sessionStorage.setItem("conectado", false);
    if (response.state) {
      let emailOtp = response.data.userdto.email;
      let celularOtp = response.data.userdto.telefono1;
      let nombresOtp = response.data.userdto.nombres.split(" ")[0];
      let dactilar = response.data.jwt.claims.dactilar;

      if (
        response.data.userdto.rol == null ||
        response.data.userdto.rol ==
          process.env.REACT_APP_USUARIO_REGISTRO.replace("{0}", origen) ||
        response.data.userdto.rol == ""
      ) {
        setEmailOtp(response.data.userdto.email);
        setCelularOtp(response.data.userdto.telefono1);
        setNombresOtp(response.data.userdto.nombres.split(" ")[0]);
        setDactilarUsr(response.data.jwt.claims.dactilar);

        //no termino de registrarse en el flujo
        try {
          const respRegistro = await obtenerRegistroCliente(
            cedula,
            localStorage.getItem("idGrupoStorage")
          );

          const esAutoservicio = eval(localStorage.getItem("autoservicio"));
          let usuarioConsulta;
          if (esAutoservicio) {
            usuarioConsulta = localStorage.getItem("nombreMaquina");
          } else {
            usuarioConsulta = `LandingWeb-${origen}`;
          }
          if (respRegistro.state) {
            sessionStorage.setItem("jwtToken", response.data.jwt.accessToken);
            localStorage.setItem("cedula", cedula);

            const datosPreev = {
              identificacion: cedula,
              usuario: authUser.key,
              local: authUser.oficina,
              origen: "SCS",
              dactilar: dactilar,
              celular: celularOtp,
              email: emailOtp,
              estacion: usuarioConsulta,
            };

            try {
              const resp = await preevaluacionClienteCredito(datosPreev);
              console.log(resp);
              if (resp.state) {
                // console.log(resp);
                const flujoRespuesta = resp.data.datosPreevaluacion.flujoFinal;
                setFlujoFinal(resp.data.datosPreevaluacion.flujoFinal);
                //setMontoSugerido(resp.data.datosMontoSugerido.valor)
                setDatosPreevaluacion(resp.data);
                let monto, montoAbastos;
                switch (flujoRespuesta) {
                  case "NEGADO":
                    setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                    setMostrarNegado(true);
                    // setLoadingPreevaluar(false);
                    setContinuaProceso(false);
                    setOpen(true);

                    break;
                  case "REVISION":
                    monto =
                      resp.data.datosMontoSugerido.valor > 2500
                        ? 2500
                        : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor;

                    setMensajeCiente(
                      "Preevaluacion exitosa, continua con la solicitud."
                    );
                    setMostrarAprobado(true);
                    // setLoadingPreevaluar(false);
                    setContinuaProceso(true);
                    setOpen(true);

                    break;
                  case "EXPRESS":
                    monto =
                      resp.data.datosMontoSugerido.valor > 2500
                        ? 2500
                        : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor.toFixed(0);

                    montoAbastos = resp.data.datosMontoSugerido.valorAbastos;
                    const textAbastos =
                      resp.data.datosPreevaluacion.idGrupo === 1
                        ? ` y para Abastos de $${montoAbastos.toFixed(0)}`
                        : ``;
                    setMensajeCiente(
                      `Felicidades tienes un monto preaprobado para Mercancias Generales de $${monto}${textAbastos} y puedes usarlos hoy mismo.`
                    );
                    setMostrarAprobado(true);
                    // setLoadingPreevaluar(false);
                    setContinuaProceso(true);
                    setOpen(true);

                    break;
                  case "DEVUELTA":
                    setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                    setMostrarAprobado(true);
                    // setLoadingPreevaluar(false);
                    setContinuaProceso(true);
                    setOpen(true);

                    break;
                  case "SolicitudActiva":
                    setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                    setMostrarNegado(true);
                    // setLoadingPreevaluar(false);
                    setContinuaProceso(false);
                    setOpen(true);

                    break;
                  default:
                    setMensajeCiente(
                      "En estos momentos no podemos realizar su Preevaluación por favor intente en unos minutos."
                    );
                    setMostrarNegado(true);
                    // setLoadingPreevaluar(false);
                    setContinuaProceso(false);
                    setOpen(true);

                    break;
                }

                // if (resp.data.validacion) {
                //   //console.log(resp.data.mensaje);
                //   setMensajeCiente(resp.data.mensaje);
                //   setMostrarAprobado(true);
                //   setLoadingPreevaluar(false);
                // } else {
                //   setMensajeCiente(resp.data.mensaje);
                //   setMostrarNegado(true);
                //   setLoadingPreevaluar(false);
                // }
              } else {
                console.log(resp.message);
                setMensajeCiente(resp.message);
                // setLoadingPreevaluar(false);
                setContinuaProceso(false);
                setOpen(true);
              }
            } catch (err) {
              console.log(err.message);
            }

            // let email = response.data.userdto.email;

            // response = await onActualizarOtp(email, cedula);

            // if (response.state) {
            //   debugger;
            //   if (celularOtp)
            //     onEnviarOtpSms(nombresOtp, response.data, celularOtp,  localStorage.getItem("cedula"));

            //   localStorage.setItem("tipocliente", "EXISTE");

            //   history.push("/auth-pages/otpregistro");
            // }
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        // que si esta complatado el flujo de prospección
        //debugger;

        sessionStorage.setItem("jwtToken", response.data.jwt.accessToken);
        localStorage.setItem("cedula", cedula);

        let email = response.data.userdto.email;

        response = await onActualizarOtp(email, cedula);

        if (response.state) {
          if (celularOtp)
            //console.log(response.data);
            onEnviarOtpSms(
              nombresOtp,
              response.data,
              celularOtp,
              localStorage.getItem("cedula"),
              localStorage.getItem("idGrupoStorage")
            );

          localStorage.setItem("tipocliente", "EXISTE");

          history.push("/auth-pages/otp");
        } else {
          alert(response.message);
          //dispatch(fetchError(data.message))
        }
      }

      //history("/home/home"); history("/home/home");
    } else {
      dispatch(fetchError(response.message));
    }

    setSubmitting(false);

    //     await onLoginCli(cedula, password)
    //       .then((response) => {

    //         console.log(response);
    //         if (response.state) {
    //             // guarda el token
    //             sessionStorage.setItem('jwtToken', data.data.jwt.accessToken);

    //             history("/home/home", {replace: true});
    //         } else console.log(response.message);
    //       })
    //       .catch((e) => {
    //         console.log(e);
    //       })
  };

  const onCallForm = () => {
    localStorage.setItem("tipocliente", "NUEVO");
    history.push("/auth-pages/validarcedula");
  };

  const redirectFlujoPunta = async (cambioCupo) => {
    let response = await onActualizarOtp(
      emailOtp,
      localStorage.getItem("cedula")
    );

    if (response.state) {
      if (celularOtp)
        onEnviarOtpSms(
          nombresOtp,
          response.data,
          celularOtp,
          localStorage.getItem("cedula"),
          localStorage.getItem("idGrupoStorage")
        );

      localStorage.setItem("tipocliente", "EXISTE");
      localStorage.setItem("cambioCupo", cambioCupo);
      localStorage.setItem("flujoFinal", flujoFinal);
      localStorage.setItem("datosPreevaluacion", JSON.stringify(datosPreevaluacion));

      history.push("/auth-pages/otpregistro");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRefresh = async () => {
    setSend(false);
    setMostrarRefresh(false);
    setRefresh(!refresh);
  };

  return (
    <>
      {!loggedUser ? (
        <Dialog
          onClose={handleCloseEspera}
          aria-labelledby="customized-dialog-title"
          open={esperaLogin}
          fullWidth
        >
          <DialogContent dividers>
            {!mostarRefresh ? (
              <Stack direction={"column"} spacing={5}>
                <Box marginTop={5}>
                  <LinearProgress color="inherit" />
                </Box>
                <Box margin={5}>
                  <Typography align="center">
                    {t("login.loadingPage")}
                  </Typography>
                </Box>
                <Box margin={5}></Box>
              </Stack>
            ) : (
              <>
                <Box margin={5}>
                  <Stack
                    direction={"column"}
                    spacing={5}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <RefreshIcon fontSize="large" />
                    <Button
                      size="lg"
                      variant="outlined"
                      //startIcon={<RefreshIcon />}
                      onClick={handleRefresh}
                    >
                      <Typography>{t("errors.login.loadingPage")}</Typography>
                    </Button>
                  </Stack>
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      ) : (
        <Div
          sx={{
            flex: 1,
            flexWrap: "wrap",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: (theme) => theme.spacing(2),
          }}
        >
          <Box
            component="img"
            src={`${process.env.REACT_APP_IMAGES_PATH}/logo-${origen}.png`}
            sx={{
              justifyContent: "center",
              width: 350,
              height: 140,
              "@media (max-width: 1500px)": { width: 300, height: "110px" },
            }}
          />
          <Card sx={{ maxWidth: "100%", width: 360, mb: 4 }}>
            <Div
              sx={{
                position: "relative",
                height: "170px",
                "@media (max-width: 1500px)": { height: "140px" },
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  backgroundColor: color,
                  height: "170px",
                  "@media (max-width: 1500px)": { height: "140px" },
                }}
              />

              <Div
                sx={{
                  flex: 1,
                  inset: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  p: (theme) => theme.spacing(3),
                }}
              >
                <Typography
                  variant={"h2"}
                  sx={{
                    color: "common.white",
                    fontSize: "1.5rem",
                    mb: 0,
                  }}
                >
                  Iniciar Sesion
                </Typography>
              </Div>
            </Div>
            <CardContent sx={{ pt: 0 }}>
              <Formik
                validateOnChange={true}
                initialValues={{
                  cedula: "",
                  password: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(data, { setSubmitting }) => {
                  onSignIn(
                    data.cedula,
                    data.password.toUpperCase(),
                    setSubmitting
                  );
                }}
              >
                {({ isSubmitting }) => (
                  <Form
                    style={{ textAlign: "left" }}
                    noValidate
                    autoComplete="off"
                  >
                    <Typography
                      sx={{ textWrap: "pretty" }}
                      textAlign={"left"}
                      variant={"h3"}
                      mb={1}
                    >
                      {t(
                        `${ORIGIN_CONNECT[origen]}.loggin` ||
                          "mensajesCreditoFav.loggin"
                      )}
                    </Typography>

                    {mutation.isError && <p>{mutation.error.message}</p>}
                    <Div sx={{ mb: 3, mt: 4 }}>
                      <JumboTextField fullWidth name="cedula" label="Cédula" />
                    </Div>
                    <Stack direction={"row"} sx={{ mb: 2, mt: 1 }}>
                      <JumboTextField
                        fullWidth
                        name="password"
                        label="Clave"
                        type="password"
                        inputProps={{
                          style: {
                            textTransform: "uppercase",
                          },
                        }}
                      />

                      <InfoPopoverButton
                        nombre={"CDL"}
                        texto={`<p> El codigo Dactilar se encuentra impreso en el reverso de la cédula de identidad, en la parte superior derecha</p>`}
                      >
                        <Stack alignItems={"center"} justifyContent={"center"}>
                          <Box
                            component="img"
                            src={`${process.env.REACT_APP_IMAGES_PATH}/dactilar.jpg`}
                            sx={{
                              justifyContent: "center",
                              height: "18vh",
                              mb: 2,
                            }}
                          />
                        </Stack>
                      </InfoPopoverButton>
                    </Stack>

                    <section style={{ margin: "15px 0" }}>
                      <SCSLoadingButton
                        loading={isSubmitting}
                        size={100}
                        type="submit"
                        titulo="Login"
                      />
                    </section>

                    <Typography textAlign={"center"} variant={"body1"} mb={1}>
                      No tienes cuenta?
                      <Link
                        underline="none"
                        href="#"
                        onClick={onCallForm}
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {` Registrate`}
                      </Link>
                    </Typography>
                  </Form>
                )}
              </Formik>
            </CardContent>
          </Card>

          <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: {
                borderRadius: 4,
                overflow: "hidden",
              },
            }}
          >
            <DialogContent
              sx={{
                backgroundColor: "#e9f0ffff",
                borderRadius: 4,
                p: 3,
              }}
            >
              <Card
                elevation={0}
                sx={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    flexWrap="wrap"
                  >
                    <Box flex="1" minWidth="220px">
                      <Typography
                        variant="h2"
                        fontWeight="bold"
                        color="text.primary"
                        // gutterBottom
                      >
                        {continuaProceso
                          ? "PREEVALUACION EXITOSA"
                          : "PREEVALUACION NO EXITOSA"}
                      </Typography>
                      <Typography
                        variant="h3"
                        color="text.secondary"
                        mb={2}
                        mt={5}
                      >
                        {mensajeCliente}
                      </Typography>
                      {continuaProceso && (
                        <Stack direction={"row"} spacing={2} mt={8}>
                          <Button
                            variant="contained"
                            onClick={() => {
                              redirectFlujoPunta(false);
                            }}
                            sx={{
                              backgroundColor: "#FFFFFF",
                              color: "#000",
                              textTransform: "none",
                              fontWeight: "bold",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                              "&:hover": { backgroundColor: "#f5f5f5" },
                              borderRadius: "9999px", // 🔘 redondeado tipo píldora
                              px: 3, // padding horizontal extra
                              "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                          >
                            Continuar
                          </Button>
                          {flujoFinal === "EXPRESS" && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                redirectFlujoPunta(true);
                              }}
                              sx={{
                                backgroundColor: "#FFFFFF",
                                color: "#000",
                                textTransform: "none",
                                fontWeight: "bold",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                                borderRadius: "9999px", // 🔘 redondeado tipo píldora
                                px: 3, // padding horizontal extra
                                "&:hover": { backgroundColor: "#f5f5f5" },
                              }}
                            >
                              Deseo Mayor Monto!
                            </Button>
                          )}
                        </Stack>
                      )}
                    </Box>

                    {/* Imagen del personaje rojo */}
                    <Box
                      component="img"
                      src={`/images/logo-preev-${authUser.usuarioFlujos[0].idGrupo}.png`}
                      alt="Figura roja"
                      sx={{
                        width: 175,
                        height: "auto",
                        ml: 2,
                        mt: { xs: 2, sm: 0 },
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </DialogContent>
          </Dialog>

          <RedirectToHome url={url} />
        </Div>
      )}
    </>
  );
};

export default Login1;
